export default {
    init() {
        this.newServiceConditionsToggle();
        this.newServiceConditionsActionToggle();
        this.conditionsRowClone();
    },

    newServiceConditionsToggle(){
        if($('.new-service-conditions-block-toggle').is(':checked') == false){
            $('.new-service-conditions-block').hide();
        }
        

        $('.new-service-conditions-block-toggle').on('click',function(){
            if ($(this).is(':checked')) {
                $('.new-service-conditions-block').slideDown(300);
            } else {
                $('.new-service-conditions-block').hide(200);
            }
        });
    },

    newServiceConditionsActionToggle(){
        // $('.new-service-condition-action-calc-block').hide();
        // $('.new-service-condition-action-calc-block .input-wrap').addClass('disabled');
        // $("body").on("select2:select", ".new-service-condition-action-select", function (e) {
        //     var select_val = $(e.currentTarget).val();
        //     if(select_val == 'new-service-condition-action-calculate'){
        //         $('.new-service-condition-action-calc-block').show();
        //         $('.new-service-condition-action-calc-block .input-wrap').removeClass('disabled');
        //         $('.new-service-condition-action-input-block').hide();
        //         $('.new-service-condition-action-input-block .input-wrap').addClass('disabled');
        //         $(".new-service-condition-action-input-block select").val('').change();
        //     } else {
        //         $('.new-service-condition-action-calc-block').hide();
        //         $('.new-service-condition-action-input-block .input-wrap').removeClass('disabled');
        //         $('.new-service-condition-action-input-block').show();
        //         $('.new-service-condition-action-calc-block .input-wrap').addClass('disabled');
        //         $(".new-service-condition-action-input-block select").val('').change();
        //     }
        // });
    },

    conditionsRowClone() {
        let select2Options = {
            placeholder: 'Select',
            minimumResultsForSearch: -1
        };

        $('body').on('click', function (e) {
            if ($(e.target).hasClass('add-row') && $(e.target).hasClass('new')) {
                let parent = $(e.target).closest('.add-row-wrap');
                parent.find('.input-wrap').removeClass('error');
                let validation = true;

                // $(".input-wrap:not(.disabled) select.select2", parent).each(function () {
                //     let element = $(this);
                //     if (element.val() === "") {
                //         validation = false;
                //         element.closest('.input-wrap').addClass('error');
                //     }
                // });
                // $(".input-wrap:not(.disabled) .form-input", parent).each(function () {
                //     let element = $(this);
                //     if (element.val() === "") {
                //         validation = false;
                //         element.closest('.input-wrap').addClass('error');
                //     }
                // });

                if (validation ==  true) {
                    $('.new-row select').select2('destroy');
                    parent.find('.input-wrap').removeClass('error');
                    let clonedRow = parent.clone();
                    var nextId = $('.add-row-wrap').length+1;
                    
                    clonedRow.find('.condition-field-type').attr('name', 'conditions['+nextId+'][field_type]');
                    clonedRow.find('.condition-fields').attr('name', 'conditions['+nextId+'][fields][]');
                    clonedRow.find('.condition-condition').attr('name', 'conditions['+nextId+'][condition]');
                    clonedRow.find('.condition-value').attr('name', 'conditions['+nextId+'][value]');

                    clonedRow.insertBefore(parent).attr('id', 'new' + getRandomInt(9, 99));
                    parent.parent().find('.add-row-wrap').eq(1).removeClass('new-row').find('.add-row.new').hide();
                    parent.parent().find('.add-row-wrap.new-row .form-input').val('');
                    parent.parent().find('.add-row-wrap').eq(1).find('.add-row.delete').addClass('show');
                    let newDeleteBtn = parent.parent().find('.add-row-wrap').eq(1).find('.add-row.delete');
                    deleteRow(newDeleteBtn);
                    $('.add-row-wrap select').select2(select2Options);
                    initMultiSelect();
                    
                }
            }
        });

        $('body').on('click', function (e) {
            if ($(e.target).hasClass('add-row') && $(e.target).hasClass('delete')) {
                $(e.target).closest('.add-row-wrap').remove();
                console.log($(this));
            }
        });
        

        function initMultiSelect(){
            let select = $('.multi-select-listing .select2');

            if($('.multi-select-listing').hasClass('multi-select-priority')){
                $('.multi-select-list').sortable({
                    revert: true,
                });
    
                $( ".multi-select-list li" ).draggable({
                    cursor: "move",
                    connectToSortable: ".multi-select-list",
                    helper: "clone",
                    revert: "invalid"
                });
            };
    
            if (select.length > 0) {
                select.select2({ allowClear: true});
    
                $('.multi-select-list').append($('.select2-selection__rendered ul'));
    
                $('.multi-select-listing select').each(function() {
                    var select = $(this);
                    var multiSelectList = select.closest('.multi-select-listing').find('.multi-select-list');
                    multiSelectList.append(select.next('.select2').find('.select2-selection__rendered ul'));
                    multiSelectList.html(select.next('.select2').find('.select2-selection__rendered').html());
                    select.on('select2:select select2:unselect', function() {
                        multiSelectList.html(select.next('.select2').find('.select2-selection__rendered').html());
                    });
    
                });
    
                $('.multi-select-listing.multi-select-priority select').on('change', function(){
                    $('.multi-select-list').sortable({
                        revert: true,
                    });
    
                    $( ".multi-select-list li" ).draggable({
                        cursor: "move",
                        connectToSortable: ".multi-select-list",
                        helper: "clone",
                        revert: "invalid"
                    });
                });
    
                $('body').on('click', '.multi-select-list .select2-selection__choice__remove', function(){
                   let unselectItem = $(this).parent().data('select2-id');
                   $(this).closest('.multi-select-listing').find('.select2-container .select2-selection__rendered .select2-selection__choice[data-select2-id="'+unselectItem+'"] button').trigger('click');
                //    console.log($(this).closest('.multi-select-listing').find('.select2-container .select2-selection__rendered .select2-selection__choice[data-select2-id="'+unselectItem+'"] button'));
    
                });
    
    
            }
    
            if($('.multi-select-listing .select2-selection__rendered').length > 0){
                $('.multi-select-list').append($('.select2-selection__rendered ul'));
            }
        }


        function deleteRow(btn) {
            // btn.on('click', function () {
            //     console.log('click');
            //     $(this).closest('.add-row-wrap').remove();
            // });
        }

        function getRandomInt(min, max) {
            min = Math.ceil(min);
            max = Math.floor(max);
            return Math.floor(Math.random() * (max - min) + min);
        }
    },

}